var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('AsStampHistoryStatusList')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-container"},[_c('h2',{staticClass:"page-sub-title mb-4"},[_vm._v("관리서비스 스탬프 현황")])])
}]

export { render, staticRenderFns }